export const HistoricalJsonExample = (systemId: string) => {
  switch (systemId) {
    case 'trondheim':
      return `[
  {
    "start_station_id": "51",
    "duration": 1630,
    "start_station_longitude": 10.37476971745491,
    "end_station_longitude": 10.39729356765747,
    "start_station_latitude": 63.430403126559675,
    "end_station_description": "Ved hurtigbåtterminalen ",
    "ended_at": "2018-10-01 04:27:59.869000+00:00",
    "end_station_id": "9",
    "end_station_latitude": 63.43740318294613,
    "end_station_name": "Brattørkaia",
    "start_station_description": " ved kryss Mellomila / Illevollen",
    "start_station_name": "Skansen",
    "started_at": "2018-10-01 04:00:49.531000+00:00"
  },
  {
    "start_station_id": "6",
    "duration": 455,
    "start_station_longitude": 10.425844341516495,
    "end_station_longitude": 10.39729356765747,
    "start_station_latitude": 63.43660495943216,
    "end_station_description": "Ved hurtigbåtterminalen ",
    "ended_at": "2018-10-01 04:13:48.137000+00:00",
    "end_station_id": "9",
    "end_station_latitude": 63.43740318294613,
    "end_station_name": "Brattørkaia",
    "start_station_description": " ved kryss Mellomveien / Innherredsveien",
    "start_station_name": "Lademoparken ",
    "started_at": "2018-10-01 04:06:12.953000+00:00"
  },
  {
    "start_station_id": "51",
    "duration": 343,
    "start_station_longitude": 10.37476971745491,
    "end_station_longitude": 10.39729356765747,
    "start_station_latitude": 63.430403126559675,
    "end_station_description": "Ved hurtigbåtterminalen ",
    "ended_at": "2018-10-01 04:13:36.356000+00:00",
    "end_station_id": "9",
    "end_station_latitude": 63.43740318294613,
    "end_station_name": "Brattørkaia",
    "start_station_description": " ved kryss Mellomila / Illevollen",
    "start_station_name": "Skansen",
    "started_at": "2018-10-01 04:07:52.671000+00:00"
  }
]`;
    case 'bergen-city-bike':
      return `[
  {
    "started_at":"2018-10-01 04:17:52.684000+00:00",
    "start_station_name":"M\u00f8llendalsplass",
    "ended_at":"2018-10-01 04:24:20.424000+00:00",
    "start_station_longitude":5.3519936304809335,
    "end_station_description":" ",
    "end_station_name":"Solheimsviken",
    "start_station_description":"ved KMD Fakultetet",
    "start_station_id":"220",
    "start_station_latitude":60.379685765470725,
    "end_station_id":"5",
    "end_station_latitude":60.37711952025095,
    "end_station_longitude":5.335721728558383,
    "duration":387
  },
  {
    "started_at":"2018-10-01 04:34:42.097000+00:00",
    "start_station_name":"Studentsenteret UIB",
    "ended_at":"2018-10-01 04:37:57.201000+00:00",
    "start_station_longitude":5.322980046239536,
    "end_station_description":"Gamle Lysverket, ved KODE",
    "end_station_name":"Lysverket",
    "start_station_description":"ved Parkveien / Olaf Ryes vei",
    "start_station_id":"49",
    "start_station_latitude":60.38719801795013,
    "end_station_id":"116",
    "end_station_latitude":60.389542524377724,
    "end_station_longitude":5.329622268545791,
    "duration":195
  },
  {
    "started_at":"2018-10-01 04:41:38.885000+00:00",
    "start_station_name":"M\u00f8llendalsplass",
    "ended_at":"2018-10-01 04:49:04.581000+00:00",
    "start_station_longitude":5.3519936304809335,
    "end_station_description":"ved Jernbanestasjonen og Bystasjonen",
    "end_station_name":"Nonneseterplass",
    "start_station_description":"ved KMD Fakultetet",
    "start_station_id":"220",
    "start_station_latitude":60.379685765470725,
    "end_station_id":"215",
    "end_station_latitude":60.38967202352878,
    "end_station_longitude":5.3336050852019525,
    "duration":445
  }
]`;
    case 'edinburgh-city-bikes':
      return `[
  {
    "started_at":"2018-10-01 01:21:40.555000+00:00",
    "start_station_name":"St Andrew Square",
    "ended_at":"2018-10-01 01:26:57.840000+00:00",
    "start_station_longitude":-3.1927736686587878,
    "end_station_description":"near Tesco's",
    "end_station_name":"Canonmills",
    "start_station_description":"North East corner",
    "start_station_id":"259",
    "start_station_latitude":55.95474881217642,
    "end_station_id":"262",
    "end_station_latitude":55.96280408759764,
    "end_station_longitude":-3.196283585062929,
    "duration":317
  },
  {
    "started_at":"2018-10-01 04:44:47.775000+00:00",
    "start_station_name":"Kings Building 3",
    "ended_at":"2018-10-01 04:47:27.430000+00:00",
    "start_station_longitude":-3.1753845849070785,
    "end_station_description":"Kings Building House",
    "end_station_name":"Kings Building 3",
    "start_station_description":"Kings Building House",
    "start_station_id":"254",
    "start_station_latitude":55.923478807846635,
    "end_station_id":"254",
    "end_station_latitude":55.923478807846635,
    "end_station_longitude":-3.1753845849070785,
    "duration":159
  },
  {
    "started_at":"2018-10-01 04:45:03.548000+00:00",
    "start_station_name":"Kings Building 3",
    "ended_at":"2018-10-01 05:14:10.466000+00:00",
    "start_station_longitude":-3.1753845849070785,
    "end_station_description":"Melville Terrace",
    "end_station_name":"Meadows East",
    "start_station_description":"Kings Building House",
    "start_station_id":"254",
    "start_station_latitude":55.923478807846635,
    "end_station_id":"265",
    "end_station_latitude":55.939809466328285,
    "end_station_longitude":-3.182738850746432,
    "duration":1746
  }
]`;
    default:
      return null;
  }
};

export const HistoricalCsvExample = (systemId: string) => {
  switch (systemId) {
    case 'trondheim':
      return `  "started_at","ended_at","duration","start_station_id","start_station_name","start_station_description","start_station_latitude","start_station_longitude","end_station_id","end_station_name","end_station_description","end_station_latitude","end_station_longitude"
  "2018-10-01 04:00:49.531000+00:00","2018-10-01 04:27:59.869000+00:00","1630","51","Skansen"," ved kryss Mellomila / Illevollen","63.430403126559675","10.37476971745491","9","Brattørkaia","Ved hurtigbåtterminalen ","63.43740318294613","10.39729356765747"
  "2018-10-01 04:06:12.953000+00:00","2018-10-01 04:13:48.137000+00:00","455","6","Lademoparken "," ved kryss Mellomveien / Innherredsveien","63.43660495943216","10.425844341516495","9","Brattørkaia","Ved hurtigbåtterminalen ","63.43740318294613","10.39729356765747"
  "2018-10-01 04:07:52.671000+00:00","2018-10-01 04:13:36.356000+00:00","343","51","Skansen"," ved kryss Mellomila / Illevollen","63.430403126559675","10.37476971745491","9","Brattørkaia","Ved hurtigbåtterminalen ","63.43740318294613","10.39729356765747"
  "2018-10-01 04:26:35.388000+00:00","2018-10-01 04:30:05.929000+00:00","210","118","Abels gate","Ved Udbyes gate","63.41614341778847","10.396314561367035","86","Lerkendal","  I Strindvegen ved Klæbuveien","63.412525462202666","10.40068656206131"
  "2018-10-01 04:38:11.066000+00:00","2018-10-01 04:42:29.483000+00:00","258","30","St Olavs gate","Ved trikkeholdeplass ","63.431170931099416","10.390283614397049","45","Studentersamfundet","sør for Eddaparken","63.42185871322338","10.39451614022255"
  "2018-10-01 04:44:34.038000+00:00","2018-10-01 04:49:12.629000+00:00","278","105","Trondheim S","Ved Sentralstasjonen","63.43605560561","10.399405807256699","30","St Olavs gate","Ved trikkeholdeplass ","63.431170931099416","10.390283614397049"
  "2018-10-01 05:01:46.410000+00:00","2018-10-01 05:06:18.326000+00:00","271","25","Thornesparken ","I Kirkegata ","63.43289961569575","10.412772931158543","105","Trondheim S","Ved Sentralstasjonen","63.43605560561","10.399405807256699"
  "2018-10-01 05:15:51.990000+00:00","2018-10-01 05:22:06.244000+00:00","374","44","Prinsen kinosenter"," ved kryss prinsens gate / Verftsgata","63.42663458755783","10.392784774303436","1","Dokkparken"," Ved kryss Innherredsveien / Verftsgata","63.433509009133566","10.411412715911865"`;
    case 'bergen-city-bike':
      return `  "started_at","ended_at","duration","start_station_id","start_station_name","start_station_description","start_station_latitude","start_station_longitude","end_station_id","end_station_name","end_station_description","end_station_latitude","end_station_longitude"
  "2018-10-01 04:17:52.684000+00:00","2018-10-01 04:24:20.424000+00:00","387","220","Møllendalsplass","ved KMD Fakultetet","60.379685765470725","5.3519936304809335","5","Solheimsviken"," ","60.37711952025095","5.335721728558383"
  "2018-10-01 04:34:42.097000+00:00","2018-10-01 04:37:57.201000+00:00","195","49","Studentsenteret UIB","ved Parkveien / Olaf Ryes vei","60.38719801795013","5.322980046239536","116","Lysverket","Gamle Lysverket, ved KODE","60.389542524377724","5.329622268545791"
  "2018-10-01 04:41:38.885000+00:00","2018-10-01 04:49:04.581000+00:00","445","220","Møllendalsplass","ved KMD Fakultetet","60.379685765470725","5.3519936304809335","215","Nonneseterplass","ved Jernbanestasjonen og Bystasjonen","60.38967202352878","5.3336050852019525"
  "2018-10-01 04:47:47.424000+00:00","2018-10-01 06:08:10.694000+00:00","4823","24","Studentboligene","ved Grønneviken og KMD fakultetet","60.378024641518735","5.350818157212416","157","Høyteknologisenteret","ved Florida bybanestopp","60.382254745562825","5.3323324699108525"
  "2018-10-01 05:17:24.666000+00:00","2018-10-01 05:25:43.494000+00:00","498","34","Cornerteateret"," Ved BI","60.382595986001995","5.325332343545597","215","Nonneseterplass","ved Jernbanestasjonen og Bystasjonen","60.38967202352878","5.3336050852019525"
  "2018-10-01 05:19:23.076000+00:00","2018-10-01 05:23:54.865000+00:00","271","217","Nykirken","ved kai","60.39723758526031","5.3140013115007605","151","Småstrandgaten","ved Xhibiton","60.39309812241306","5.327022724925882"
  "2018-10-01 05:23:32.352000+00:00","2018-10-01 05:29:56.981000+00:00","384","217","Nykirken","ved kai","60.39723758526031","5.3140013115007605","116","Lysverket","Gamle Lysverket, ved KODE","60.389542524377724","5.329622268545791"
  "2018-10-01 05:24:03.825000+00:00","2018-10-01 05:30:22.996000+00:00","379","58","Tårnplass"," Tårnplass ved Tinghuset","60.39375532002469","5.3217920958013565","214","Media City","Nygårdsgaten ved SVV","60.3839343833222","5.333450454511649"`;
    case 'edinburgh-city-bikes':
      return `  "started_at","ended_at","duration","start_station_id","start_station_name","start_station_description","start_station_latitude","start_station_longitude","end_station_id","end_station_name","end_station_description","end_station_latitude","end_station_longitude"
  "2018-10-01 01:21:40.555000+00:00","2018-10-01 01:26:57.840000+00:00","317","259","St Andrew Square","North East corner","55.95474881217642","-3.1927736686587878","262","Canonmills","near Tesco's","55.96280408759764","-3.196283585062929"
  "2018-10-01 04:44:47.775000+00:00","2018-10-01 04:47:27.430000+00:00","159","254","Kings Building 3","Kings Building House","55.923478807846635","-3.1753845849070785","254","Kings Building 3","Kings Building House","55.923478807846635","-3.1753845849070785"
  "2018-10-01 04:45:03.548000+00:00","2018-10-01 05:14:10.466000+00:00","1746","254","Kings Building 3","Kings Building House","55.923478807846635","-3.1753845849070785","265","Meadows East","Melville Terrace","55.939809466328285","-3.182738850746432"
  "2018-10-01 04:53:03.261000+00:00","2018-10-01 04:58:42.537000+00:00","339","255","Kings Buildings 4","X-Y Cafe","55.92200087060626","-3.1769018141649212","254","Kings Building 3","Kings Building House","55.923478807846635","-3.1753845849070785"
  "2018-10-01 05:01:40.443000+00:00","2018-10-01 05:15:36.416000+00:00","835","252","Kings Buildings 1","Grant Institute","55.92418540667696","-3.173830830087809","265","Meadows East","Melville Terrace","55.939809466328285","-3.182738850746432"
  "2018-10-01 05:11:01.537000+00:00","2018-10-01 05:22:27.201000+00:00","685","262","Canonmills","near Tesco's","55.96280408759764","-3.196283585062929","250","Victoria Quay","Entrance to Scottish Government Office","55.977637787726984","-3.174115590621568"
  "2018-10-01 05:38:50.062000+00:00","2018-10-01 05:45:17.345000+00:00","387","261","Brunswick Place","Junction Brunswick Street and Elm Row","55.960929747664","-3.1810053147805775","225","Waverley Court","On Waverley Court forecourt","55.95173449698344","-3.1841785354060903"
  "2018-10-01 06:19:11.895000+00:00","2018-10-01 06:31:44.031000+00:00","752","250","Victoria Quay","Entrance to Scottish Government Office","55.977637787726984","-3.174115590621568","262","Canonmills","near Tesco's","55.96280408759764","-3.196283585062929"`;
    default:
      return null;
  }
};

export const RealtimeSystemInformationExample = (systemId: string) => {
  switch (systemId) {
    case 'trondheim':
      return `{
  "last_updated": 1540218289,
  "ttl": 10,
  "data": {
    "system_id": "trondheim",
    "language": "nb",
    "name": "Trondheim City Bike",
    "operator": "UIP Trondheim Bysykkel AS",
    "timezone": "Europe/Oslo",
    "phone_number": "+4794858825",
    "email": "post@trondheimbysykkel.no"
  }
}`;
    case 'bergen-city-bike':
      return `{
  "last_updated": 1540309494,
  "ttl": 10,
  "data": {
    "system_id": "bergen-city-bike",
    "language": "nb",
    "name": "Bergen City Bike",
    "operator": "Urban Infrastructure Partner",
    "timezone": "Europe/Oslo",
    "phone_number": "90259737",
    "email": "post@bergenbysykkel.no"
  }
}`;
    case 'edinburgh-city-bikes':
      return `{
  "last_updated": 1540309639,
  "ttl": 10,
  "data": {
    "system_id": "edinburgh-city-bikes",
    "language": "en",
    "name": "Just Eat Cycles",
    "operator": "SERCO",
    "timezone": "Europe/London",
    "phone_number": "+4401312783000",
    "email": "support@edinburghcyclehire.com"
  }
}`;
    case 'oslobysykkel':
      return `{
  "last_updated": 1553592653, 
  "ttl": 10, 
  "data": {
    "system_id": "oslobysykkel", 
    "language": "nb", 
    "name": "Oslo Bysykkel", 
    "operator": "UIP Oslo Bysykkel AS", 
    "timezone": "Europe/Oslo", 
    "phone_number": "+4791589700", 
    "email": "post@oslobysykkel.no"
  }
}`;
    default:
      return null;
  }
};

export const RealtimeStationInformationExample = (systemId: string) => {
  switch (systemId) {
    case 'trondheim':
      return `{
  "last_updated": 1540219057,
  "data": {
    "stations": [
      {
        "capacity": 15,
        "lat": 63.4304427209203,
        "address": "Kongensgate 15",
        "name": "Torvet I",
        "station_id": "175",
        "lon": 10.392744433633425
      },
      {
        "capacity": 13,
        "lat": 63.429289773431165,
        "address": "Illevollen",
        "name": "Ilaparken",
        "station_id": "47",
        "lon": 10.369248388233245
      },
      {
        "capacity": 13,
        "lat": 63.40575407332705,
        "address": "Sorgenfriveien 7",
        "name": "Sorgenfri",
        "station_id": "10",
        "lon": 10.399830937385559
      }
    ]
  }
}`;
    case 'bergen-city-bike':
      return `{
 "last_updated": 1540309984,
 "data": {
    "stations": [
       {
          "address": "Kaigaten",
          "capacity": 19,
          "lon": 5.327895003562276,
          "name": "R\u00e5dhuset",
          "station_id": "223",
          "lat": 60.39168071231371
       },
       {
          "address": "M\u00e5sekj\u00e6ret",
          "capacity": 10,
          "lon": 5.320473627367278,
          "name": "Sandviken Brygge",
          "station_id": "222",
          "lat": 60.41292872155995
       },
       {
          "address": "sandvikstorget 11",
          "capacity": 19,
          "lon": 5.322648583141813,
          "name": "Sandvikstorget",
          "station_id": "221",
          "lat": 60.408582102784685
       }
     ]
   }
 }`;
    case 'edinburgh-city-bikes':
      return `{
 "last_updated": 1540310074,
 "data": {
    "stations": [
       {
          "address": "Ocean Drive",
          "capacity": 25,
          "lon": -3.176351263805259,
          "name": "Ocean Terminal",
          "station_id": "285",
          "lat": 55.981286014792985
       },
       {
          "address": "Vanburgh Place",
          "capacity": 37,
          "lon": -3.1668846170233564,
          "name": "Leith Links",
          "station_id": "284",
          "lat": 55.96919856910954
       },
       {
          "address": "Near Waitrose Car Park Entrance",
          "capacity": 20,
          "lon": -3.2234280553759618,
          "name": "Waitrose, Comely Bank",
          "station_id": "277",
          "lat": 55.959504176688824
       }
     ]
   }
 }`;
    case 'oslobysykkel':
      return `{
  "last_updated": 1553592653,
  "data": {
    "stations": [
      {  
        "station_id":"627",
        "name":"Sk\u00f8yen Stasjon",
        "address":"Sk\u00f8yen Stasjon",
        "lat":59.9226729,
        "lon":10.6788129,
        "capacity":20
      },
      {  
        "station_id":"623",
        "name":"7 Juni Plassen",
        "address":"7 Juni Plassen",
        "lat":59.9150596,
        "lon":10.7312715,
        "capacity":15
      },
      {  
        "station_id":"610",
        "name":"Sotahj\u00f8rnet",
        "address":"Sotahj\u00f8rnet",
        "lat":59.9099822,
        "lon":10.7914482,
        "capacity":20
      }
    ]
  }
}`;
    default:
      return null;
  }
};

export const RealtimeGbfsJsonExample = (systemId: string) => {
  switch (systemId) {
    case 'trondheim':
      return `{
  "data":{
    "nb":{
      "feeds":[
        {
          "url":"https://gbfs.urbansharing.com/trondheimbysykkel.no/system_information.json",
          "name":"system_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/trondheimbysykkel.no/station_information.json",
          "name":"station_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/trondheimbysykkel.no/station_status.json",
          "name":"station_status"
        }
      ]
    }
  },
  "ttl":10,
  "last_updated":1542035150
}`;
    case 'bergen-city-bike':
      return `{
  "data":{
    "nb":{
      "feeds":[
        {
          "url":"https://gbfs.urbansharing.com/bergenbysykkel.no/system_information.json",
          "name":"system_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/bergenbysykkel.no/station_information.json",
          "name":"station_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/bergenbysykkel.no/station_status.json",
          "name":"station_status"
        }
      ]
    }
  },
  "ttl":10,
  "last_updated":1542035150
}`;
    case 'edinburgh-city-bikes':
      return `{
  "data":{
    "en":{
      "feeds":[
        {
          "url":"https://gbfs.urbansharing.com/edinburghcyclehire.com/system_information.json",
          "name":"system_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/edinburghcyclehire.com/station_information.json",
          "name":"station_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/edinburghcyclehire.com/station_status.json",
          "name":"station_status"
        }
      ]
    }
  },
  "ttl":10,
  "last_updated":1542035150
}`;
    case 'oslobysykkel':
      return `{
  "data":{
    "nb":{
      "feeds":[
        {
          "url":"https://gbfs.urbansharing.com/oslobysykkel.no/system_information.json",
          "name":"system_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/oslobysykkel.no/station_information.json",
          "name":"station_information"
        },
        {
          "url":"https://gbfs.urbansharing.com/oslobysykkel.no/station_status.json",
          "name":"station_status"
        }
      ]
    }
  },
  "ttl":10,
  "last_updated":1553592630
}`;
    default:
      return null;
  }
};
